// Admin / Owner session helpers.
//
// Storage choice: localStorage. The admin & owner tokens are scoped to the
// admin panel and owner dashboard respectively. The threat model is small
// (no PII or financial data is stored client-side) so we accept the standard
// localStorage tradeoff. If we ever expand to billing-sensitive owner
// actions, swap these for httpOnly cookies via a `/api/session` endpoint.
const ADMIN_KEY = "halalmap_admin_token";
const OWNER_KEY = "halalmap_owner_token";
const OWNER_EMAIL_KEY = "halalmap_owner_email";

const safeGet = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (err) {
    // Some browsers (private mode, embedded webviews) deny access; treat as
    // signed-out and log so we can spot a misconfigured browser in support.
    console.warn(`[session] localStorage.getItem failed for ${key}:`, err.message);
    return null;
  }
};

const safeSet = (key, value) => {
  try {
    if (value == null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch (err) {
    console.warn(`[session] localStorage.setItem failed for ${key}:`, err.message);
  }
};

export const getAdminToken = () => safeGet(ADMIN_KEY);
export const setAdminToken = (t) => safeSet(ADMIN_KEY, t);

export const getOwnerToken = () => safeGet(OWNER_KEY);
export const setOwnerToken = (t, email) => {
  safeSet(OWNER_KEY, t);
  // Email is paired with the token — clear it whenever the token is cleared.
  safeSet(OWNER_EMAIL_KEY, t ? email || null : null);
};

export const getOwnerEmail = () => safeGet(OWNER_EMAIL_KEY);
